import { ComponentSharedImageCardSection } from '@peerless/data-access/strapi';
import { CardActionArea, Grid, Stack } from '@mui/material';
import { withSectionLayout } from './SectionLayout';
import { SectionHeader } from './SectionHeader';
import { ImageCard } from './ImageCard';
import { isValidUrl } from '../utils';
import { CallToActionSection } from './CallToActionSection';

interface ImageCardSectionProps {
  data: ComponentSharedImageCardSection;
}

function _ImageCardSection({ data }: ImageCardSectionProps) {
  const { callToAction } = data;
  return (
    <Stack gap={4}>
      <SectionHeader {...data.sectionHeader} />
      <Grid container spacing={3} justifyContent={'center'}>
        {data.imageCards?.map(card => {
          const target = isValidUrl(card.linkUrl) ? '_blank' : '_self';
          return (
            <Grid item xs={12} md={6} lg={4} key={card.id} display={'flex'}>
              <CardActionArea
                href={card.linkUrl}
                target={target}
                sx={{ '&:hover .MuiCardActionArea-focusHighlight': { opacity: '0' } }}
              >
                <ImageCard {...card} />
              </CardActionArea>
            </Grid>
          );
        })}
      </Grid>
      <CallToActionSection callToAction={callToAction} />
    </Stack>
  );
}

export const ImageCardSection = withSectionLayout(_ImageCardSection);
